import cn from 'classnames';
import React, {FC} from 'react';

import {AppButton} from '../../../../../components/Button';
import appConfig from '../../../../../config/appConfig';
import * as localizationKeys from '../../../../../consts/localization/localizationKeys';
import NotificationModalTypes from '../../../../../enums/app/notificationModalTypes';
import {getLocalizedStrings} from '../../../../../services/localization/localizationService';
import marketConfigService from '../../../../../services/marketConfigService';
import appRouterService from '../../../../../services/route/appRouterService';
import routerService from '../../../../../services/routerService';
import {removeNotificationType} from '../../../../../state/ducks/global';
import {dispatch} from '../../../../../state/store';

const PromotedRegistrationNotification: FC = () => {
    const localizedStrings = getLocalizedStrings();
    const notificationText = localizedStrings[localizationKeys.NON_MANDATORY_REGISTRATION_NOTIFICATION_TEXT];
    const buttonText = localizedStrings[localizationKeys.NON_MANDATORY_REGISTRATION_NOTIFICATION_BUTTON];
    const isDeviceRegistrationEnabled = marketConfigService.isDeviceRegistrationEnabled();
    const productRegistrationUrl = appConfig.getProductRegistrationUrlFormatted();

    const onButtonClick = () => {
        if (!isDeviceRegistrationEnabled && productRegistrationUrl) {
            routerService.redirect(productRegistrationUrl);
        } else {
            dispatch(removeNotificationType(NotificationModalTypes.PROMOTED_REGISTRATION));
            appRouterService.forwardToAboutDevicePage();
        }
    };

    return (
        <>
            <span className={cn({'pr-1': notificationText})}>{notificationText}</span>
            <AppButton onClick={onButtonClick} tertiary className='inline-block'>
                {buttonText}
            </AppButton>
        </>
    );
};

export default PromotedRegistrationNotification;
